<template>
  <div class="main-div ">
    <div
      class="bg-main-color1"
      style="
        padding: 10px;
        color: #fff;
        display: flex;
        justify-content: space-between;
      "
    >
      <div>
        <strong>{{ label }}</strong>
      </div>
      <button
        class="bg-main-color1"
        style="color: #fff"
        @click.prevent="toggle = !toggle"
        v-show="!toggle"
      >
        Show
      </button>
      <button
        class="bg-main-color1"
        style="color: #fff"
        @click.prevent="toggle = !toggle"
        v-show="toggle"
      >
        Hide
      </button>
    </div>
    <div class="box-div" v-show="toggle">
      <div class="box">
        <h2>Find / Add / Edit User</h2>
        <br />

        <ButtonSubmit label="See More" @click="goTo('manage_user')" />
      </div>

      <div class="box">
        <h2>Iteration Control Center</h2>
        <br />

        <ButtonSubmit label="See More" @click="goTo('AdminDashboard')" />
      </div>

      <div class="box">
        <h2>Add Users</h2>

        <br />

        <ButtonSubmit label="See More" @click="goTo('upload_many_users_at_once')" />
      </div>

      <!-- <div class="box">
        <h2>Add Individual Survey</h2>
        <br />

        <ButtonSubmit label="See More" @click="goTo('Add_survey')"/>
      </div> -->

<!--
<div class="box">
  <h2>Release reports for</h2>
  <br />

  <div v-if="iterations.length === 0">
    <p>No iterations today</p>
  </div>

  <div v-else-if="iterations.length === 1">
    <p>{{ iterations[0].iteration_name }}</p>
    <small
      class="tooltip"
      :title="`${iterations[0].org_name} / ${iterations[0].suborg_name} / ${iterations[0].program_name}`"
    >
      ℹ️
    </small>
    <br />
    <ButtonSubmit label="Run API" @click="runApi(iterations[0].iteration_id)" />
  </div>


  <div v-else>
    <p>{{ iterations.length }} iterations today</p>

    <ButtonSubmit
      :label="showIterations ? 'Hide' : 'Show All'"
      @click="showIterations = !showIterations"
    />
    <br />
    <ul v-if="showIterations" style="margin-top:10px;list-style:none;">
      <li
        v-for="iter in iterations"
        :key="iter.iteration_id"
        class="iteration-item"
        :title="`${iter.org_name} / ${iter.suborg_name} / ${iter.program_name}`"
      >
        {{ iter.iteration_name }}
      </li>
    </ul>

    <br />
    <ButtonSubmit label="Run API" @click="runApi()" />
  </div>
</div>
-->



    </div>
  </div>
</template>

<script>
import api from "../api/api";
import ButtonSubmit from "./ButtonSubmit.vue";

export default {
  name: "HomeAdminTasks",
  props: {
    reportName: String,
    surveyName: String,
    dateTime: String,
    buttonLabel: String,
    buttonColor: String,
    label: String,
  },
  data: () => ({
    toggle: true,
    iterations: [],
    showIterations: false,
  }),
  methods: {
    goTo(route) {
      this.$router.push({ name: route });
    },
    async fetchIterations() {
      try {
        const res = await api.get("/todays-iterations", {});
        this.iterations = res.data || [];
      } catch (err) {
        console.error("Error fetching iterations:", err);
      }
    },
    async runApi(iterationId = null) {
      console.log('iterationId', iterationId)
    }
  },

  mounted() {
    // this.fetchIterations();
  },
  components: { ButtonSubmit },
};
</script>

<style scoped>
.iteration-item {
  cursor: pointer;
  margin: 5px 0;
  padding: 3px 6px;
  border-radius: var(--radius, 0.25rem);
  background: var(--surface-container-low, #eff4ff);
  transition: background 0.2s;
}
.iteration-item:hover {
  background: var(--surface-container, #e5eeff);
}
.tooltip {
  cursor: help;
  margin-left: 6px;
  color: var(--outline, #737781);
}
.main-div {
  min-width: 75vw;
  margin: 0;
  font-family: var(--font-family, 'Inter', sans-serif);
}
.label-btn {
  color: var(--on-primary, #ffffff);
  background-color: var(--primary, #002955);
}
.label-div {
  padding: var(--space-xs, 8px) var(--space-sm, 16px);
  border: 1px solid var(--primary, #002955);
  background-color: var(--primary, #002955);
  color: var(--on-primary, #ffffff);
  display: flex;
  justify-content: space-between;
}
.box-div {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-xs, 8px);
}
.box {
  border: 1px solid var(--card-border, #e2e8f0);
  border-radius: var(--radius-lg, 0.5rem);
  font-family: var(--font-family, 'Inter', sans-serif);
  margin: var(--space-sm, 16px) 0;
  padding: var(--space-sm, 16px);
  box-shadow: none;
  background: var(--card-bg, #ffffff);
  min-height: 150px;
  min-width: 205px;
  max-width: 205px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}
.box:hover {
  box-shadow: var(--shadow-hover, 0px 4px 20px rgba(18, 63, 117, 0.05));
  border-color: var(--primary-container, #123f75);
}
.box h2 {
  font-size: var(--headline-md-size, 18px);
  font-weight: var(--headline-md-weight, 600);
  color: var(--on-surface, #0b1c30);
}
.btn { width: 100%; }

@media only screen and (min-width: 280px) and (max-width: 540px) {
  .main-div { margin: 0; }
}
</style>
